const config = {
  API_URL: process.env.REACT_APP_API_URL || '/api',
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  APP_NAME: 'Masavit',
  APP_VERSION: '1.0.0',
  DATE_FORMAT: 'DD/MM/YYYY',
  ROWS_PER_PAGE: 10,
  TOAST_AUTO_CLOSE: 3000,
  DEFAULT_LANGUAGE: 'he',
  SUPPORTED_LANGUAGES: ['he', 'en'],
  TOKEN_KEY: 'masavit_token',
  USER_KEY: 'masavit_user'
};

export default config;